export default function News() {
  const newsItems = [
    {
      date: '2024.01.15',
      category: 'プレスリリース',
      title: '新サービス「プレミアム運用管理プラン」の提供開始について'
    },
    {
      date: '2024.01.08',
      category: 'お知らせ',
      title: '年末年始の営業時間変更に関するご案内'
    },
    {
      date: '2023.12.20',
      category: '実績報告',
      title: '2023年度取引実績が前年比130%を達成'
    },
    {
      date: '2023.12.10',
      category: 'セミナー',
      title: 'バケーションレンタル事業セミナー開催のお知らせ'
    },
    {
      date: '2023.11.25',
      category: 'プレスリリース',
      title: '九州エリアへの事業拡大について'
    },
    {
      date: '2023.11.15',
      category: 'お知らせ',
      title: '新オフィス開設のご案内（大阪支社）'
    }
  ];

  return (
    <section id="news" className="bg-[#F8F8F8] py-28">
      <div className="max-w-[1400px] mx-auto px-8">
        <h2 className="font-serif text-[36px] text-black mb-16 ml-[10%]">お知らせ</h2>
        
        <div className="max-w-[1100px] mx-auto">
          {newsItems.map((item, index) => (
            <a
              key={index}
              href="#"
              className="flex items-center bg-white border-b border-[#E5E5E5] py-6 px-8 hover:bg-[#FAFAFA] transition-colors duration-200 cursor-pointer group"
            >
              <div className="w-[120px] flex-shrink-0 text-[14px] text-[#666666]">
                {item.date}
              </div>
              <div className="w-[100px] flex-shrink-0 mx-6">
                <span className="inline-block px-3 py-1 border border-[#E5E5E5] rounded text-[12px] text-[#666666] bg-white">
                  {item.category}
                </span>
              </div>
              <div className="flex-1 text-[16px] text-black group-hover:underline">
                {item.title}
              </div>
              <div className="w-6 h-6 flex items-center justify-center ml-4">
                <i className="ri-arrow-right-line text-[20px] text-[#666666]" />
              </div>
            </a>
          ))}
          
          <div className="text-right mt-8">
            <a
              href="#"
              className="inline-flex items-center text-[15px] text-[#2C2C2C] hover:text-[#1A3A52] transition-colors duration-200 cursor-pointer group"
            >
              <span className="mr-2">一覧を見る</span>
              <i className="ri-arrow-right-line text-[18px] group-hover:translate-x-1 transition-transform duration-200" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
